import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { IListByFilterQuestionarios, IQuestionarios } from '../models/questionarios';

@Injectable({
  providedIn: 'root'
})
export class QuestionariosService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}Company`;

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }
  //  listarTodosFiliaisPorCompanyId(companyId: string): Observable<ResponseDefault<IFilial[]>> {
  //   return this.http.get<ResponseDefault<IFilial[]>>(`${this.apiUrl}/ListByCompanyIdAsync?companyId=${companyId}`);
  // }

  listarTodasQuestionarios(filtros: IListByFilterQuestionarios): Observable<ResponseDefault<IQuestionarios[]>> {
    return this.http.post<ResponseDefault<IQuestionarios[]>>(`${this.apiUrl}/ListByFilterAsync`, filtros);
  }

  detalhesQuestionarios(id: string): Observable<ResponseDefault<IQuestionarios>> {
    return this.http.get<ResponseDefault<IQuestionarios>>(`${this.apiUrl}/${id}`);
  }

  adicionarQuestionarios(filial: IQuestionarios): Observable<ResponseDefault<string>> {
    return this.http.post<ResponseDefault<string>>(`${this.apiUrl}`, filial);
  }

  editarQuestionarios(filial: IQuestionarios): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}`, filial);
  }
  // exportarExcel(): void {
  //   this.http.get<IExcelDownloadResponseFilial>(`${this.apiUrl}/ExportExcel`).subscribe((resposta) => {
  //     saveAs(`data:${resposta.contentType};base64,${resposta.fileContents}`, resposta.fileDownloadName);
  //   });
  // }

  ativarQuestionarios(id: string): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/setActiveAsync/${id}`, {});
  }

  desativarQuestionarios(id: string): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/setInactiveAsync/${id}`, {});
  }
}
